import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedReducer } from './reducers';
import { SharedStoreEffects } from './effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('shared', SharedReducer),
    EffectsModule.forFeature([SharedStoreEffects]),
  ],
  providers: [SharedStoreEffects],
})
export class SharedStoreModule {}
